import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-toast"
}
const _hoisted_2 = { class: "c-toast__container" }
const _hoisted_3 = {
  key: 0,
  class: "notice"
}
const _hoisted_4 = {
  key: 1,
  class: "item"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "item__info" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 2,
  class: "message"
}
const _hoisted_10 = { class: "c-toast__footer" }
const _hoisted_11 = {
  key: 0,
  class: "actions"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "progress" }

import { computed, ref, watch } from 'vue';

import CheckmarkIcon from '@web/assets/icon/checkmark.svg';
import ErrorIcon from '@web/assets/icon/error.svg';
import InfoIcon from '@web/assets/icon/information.svg';
import WarningIcon from '@web/assets/icon/warning.svg';
import CloseIcon from '@web/assets/icon/plus.svg';

import { useGlobalStore } from '../stores/globalStore';
import PriceObject from './objects/PriceObject.vue';
import { MegaToastActions } from '../@types/generated/MegaToastActions';

export default /*@__PURE__*/_defineComponent({
  __name: 'MegaToast',
  setup(__props) {

const globalStore = useGlobalStore();

const isOpen = ref(false);
const time = ref(0);
let timer: number | undefined;

watch(
  () => globalStore.toast,
  () => {
    update();
  }
);

const response = computed(() => {
  return globalStore.response;
});

function update() {
  isOpen.value = false;

  setTimeout(() => {
    isOpen.value = true;
    reset();
  }, 200);
}

function close() {
  clearInterval(timer);
  isOpen.value = false;
}

const start = () => {
  timer = setInterval(() => {
    if (time.value > 0) {
      time.value--;
    } else {
      close();
    }
  }, 1000);
};

const reset = () => {
  clearInterval(timer);
  time.value = 10;
  start();
};

function handleAction(action: MegaToastActions) {
  isOpen.value = false;

  if (action.type == 'url') {
    return (window.location.href = action.url);
  }

  switch (action.url) {
    case 'cart':
      globalStore.openCart();
      break;
    case 'login':
      globalStore.openLogin();
      break;
    case 'close':
      close();
      break;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "toast-right" }, {
    default: _withCtx(() => [
      (isOpen.value && response.value)
        ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(["c-toast__header", ['c-toast__header--' + response.value.type]])
            }, [
              (response.value.success)
                ? (_openBlock(), _createBlock(_unref(CheckmarkIcon), { key: 0 }))
                : _createCommentVNode("", true),
              (response.value.error)
                ? (_openBlock(), _createBlock(_unref(ErrorIcon), { key: 1 }))
                : _createCommentVNode("", true),
              (response.value.warning)
                ? (_openBlock(), _createBlock(_unref(WarningIcon), { key: 2 }))
                : _createCommentVNode("", true),
              (response.value.info)
                ? (_openBlock(), _createBlock(_unref(InfoIcon), { key: 3 }))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "close",
                onClick: close
              }, [
                _createVNode(_unref(CloseIcon))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["c-toast__content", ['c-toast__content--' + response.value.type]])
              }, [
                (response.value.warning || response.value.info)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("h3", null, _toDisplayString(response.value.message), 1),
                      _createElementVNode("p", null, "Stregkode: " + _toDisplayString(response.value.barcode), 1)
                    ]))
                  : _createCommentVNode("", true),
                (response.value.variant)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("a", {
                        href: response.value.variant.url,
                        class: "item__image"
                      }, [
                        _createElementVNode("img", {
                          src: response.value.variant.images[0].src,
                          alt: response.value.variant.images[0].alt
                        }, null, 8, _hoisted_6)
                      ], 8, _hoisted_5),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("h3", null, _toDisplayString(response.value.variant.name), 1),
                        (response.value.variant.description)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(response.value.variant.description), 1))
                          : _createCommentVNode("", true),
                        _cache[0] || (_cache[0] = _createElementVNode("p", null, "Pose med 10 kg bomuldsklude", -1)),
                        (response.value.success)
                          ? (_openBlock(), _createBlock(PriceObject, {
                              key: 1,
                              price: response.value.variant.price,
                              compact: false,
                              vat: true
                            }, null, 8, ["price"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(response.value.message), 1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_10, [
                (response.value.actions.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(response.value.actions, (action) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "actions__button",
                          onClick: ($event: any) => (handleAction(action))
                        }, _toDisplayString(action.label), 9, _hoisted_12))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["progress__bar", ['progress__bar--' + response.value.type]]),
                    style: _normalizeStyle({ width: (time.value / 10) * 100 + '%' })
                  }, null, 6)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})